var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchivarFactura(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23.999,
    viewBox: "0 0 20 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "archivar-factura",
    d: "M19.95,5.536,16.465,2.051A6.954,6.954,0,0,0,11.515,0H7A5,5,0,0,0,2,5V19a5.006,5.006,0,0,0,5,5H17a5.006,5.006,0,0,0,5-5V10.485a6.956,6.956,0,0,0-2.05-4.95ZM18.536,6.95A5.031,5.031,0,0,1,19.341,8H15a1,1,0,0,1-1-1V2.659a5.005,5.005,0,0,1,1.05.805l3.485,3.485ZM20,19a3,3,0,0,1-3,3H7a3,3,0,0,1-3-3V5A3,3,0,0,1,7,2h4.515c.163,0,.325.008.485.023V7a3,3,0,0,0,3,3h4.977c.015.16.023.322.023.485V19Zm-4.5-6h-7A2.5,2.5,0,0,0,6,15.5v2A2.5,2.5,0,0,0,8.5,20h7A2.5,2.5,0,0,0,18,17.5v-2A2.5,2.5,0,0,0,15.5,13Zm.5,4.5a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5ZM6,10A1,1,0,0,1,7,9H9a1,1,0,0,1,0,2H7A1,1,0,0,1,6,10ZM6,6A1,1,0,0,1,7,5H9A1,1,0,0,1,9,7H7A1,1,0,0,1,6,6Z",
    transform: "translate(-2 -0.001)",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivarFactura);
export default __webpack_public_path__ + "static/media/archivar-factura.1f25b2d8b61c80a7ee1159bf65ca1a52.svg";
export { ForwardRef as ReactComponent };